import { render } from "./view-proforma-invoice.vue?vue&type=template&id=6cfc5d5e&scoped=true"
import script from "./view-proforma-invoice.vue?vue&type=script&lang=js"
export * from "./view-proforma-invoice.vue?vue&type=script&lang=js"

import "./view-proforma-invoice.vue?vue&type=style&index=0&id=6cfc5d5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfc5d5e"]])

export default __exports__